module.exports = __webpack_public_path__ + "f6a5245a1e4b361db7ff60c38e559030.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/browser/phones.png
// module id = 5670
// module chunks = 24